import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { extendURLParams } from "@/utils/fetchData";
import { Box } from "@mm/ui";
const StyledInfoBox = styled("div") `
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 20px;
  color: white;
  padding: 40px;
  background-color: ${({ theme }) => theme.colors.brand.primary};
  border-radius: ${({ theme }) => theme.borders.radius};
  overflow: hidden;

  ::before {
    content: "";
    display: block;
    position: absolute;
    top: -80px;
    left: -14%;
    width: 80%;
    height: 160%;
    border-top-right-radius: 180%;
    border-bottom-right-radius: 180%;
    background-color: ${({ theme }) => theme.colors.brand.primary};
    filter: brightness(0.9);
    z-index: 1;
  }

  @media (min-width: ${({ theme }) => theme.breakpointsMap.md.min}px) {
    flex-direction: row;
  }
`;
const StyledSpacer = styled("span") `
  position: relative;
  display: none;
  z-index: 3;

  ::after {
    content: "";
    display: block;
    position: absolute;
    top: calc(50% - 2px);
    height: 2px;
    width: 100%;
    background-color: white;
  }

  @media (min-width: ${({ theme }) => theme.breakpointsMap.md.min}px) {
    display: block;
    height: 100px;
    width: 5vw;
    max-width: 100px;
    margin: 0 -42.5px;
  }

  @media (min-width: ${({ theme }) => theme.breakpointsMap.lg.min}px) {
    margin: 0 -55px;
  }

  @media (min-width: ${({ theme }) => theme.breakpointsMap.xl.min}px) {
    margin: 0 -65px;
  }
`;
const StyledHeadlineWrapper = styled("div") `
  display: flex;
  align-items: center;
  flex-basis: 100%;
  z-index: 3;
  margin-bottom: 20px;

  .styledHeadline {
    font-size: 24px;
    font-weight: 600;
  }
`;
const StyledBox = styled(Box) `
  display: flex;
  align-items: center;
  z-index: 3;

  p {
    text-align: left;
    padding: 20px;
    margin: 0;
    max-width: 250px;
  }

  @media (min-width: ${({ theme }) => theme.breakpointsMap.md.min}px) {
    flex-direction: column;
    flex-basis: 200px;
    p {
      text-align: center;
      padding: 20px 20px 0 20px;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpointsMap.lg.min}px) {
    flex-basis: 200px;
  }
`;
const StyledIcon = styled("div") `
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: white;

  img {
    transform: scale(1.3);
    max-height: 40px;

    &.step02 {
      position: relative;
      left: -5px;
      top: 3px;
      transform: scale(1);
    }
  }
`;
// https://storage.googleapis.com/content-ekontor24/mediamarkt/svgs/campains/samsung-handraiser/step1.svg
const HandraiserInfoBox = () => {
    return (_jsxs(StyledInfoBox, { children: [_jsx(StyledHeadlineWrapper, {}), _jsxs(StyledBox, { children: [_jsx(StyledIcon, { children: _jsx("img", { src: `${extendURLParams().cdnUrl}/svgs/campains/samsung-handraiser/step1.svg`, alt: "" }) }), _jsx("p", { children: "Melde dich mit deiner E-Mail Adresse an." })] }), _jsx(StyledSpacer, {}), _jsxs(StyledBox, { children: [_jsx(StyledIcon, { children: _jsx("img", { src: `${extendURLParams().cdnUrl}/svgs/campains/samsung-handraiser/step2.svg`, alt: "" }) }), _jsx("p", { children: "Best\u00E4tige deine E-Mail Adresse." })] }), _jsx(StyledSpacer, {}), _jsxs(StyledBox, { children: [_jsx(StyledIcon, { children: _jsx("img", { src: `${extendURLParams().cdnUrl}/svgs/campains/samsung-handraiser/step5.svg`, alt: "" }) }), _jsx("p", { children: "Wir informieren dich \u00FCber deinen Gewinn per Mail." })] })] }));
};
export default HandraiserInfoBox;
